import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'

import { logIn } from 'state/actions'
import { getLoggedUser } from 'lib/reader'

import LogInScreen from 'components/_Screens/LogIn'

class LogInContainer extends React.Component {
  render() {
    const { logIn, loggedUser, ui } = this.props
    if (loggedUser) return <Redirect to='/' />
    return <LogInScreen onSubmit={logIn} ui={ui} />
  }
}

LogInContainer.propTypes = {
  loggedUser: PropTypes.object,
  ui: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  loggedUser: getLoggedUser(state),
  ui: state.ui,
})

export default withRouter(connect(
  mapStateToProps,
  { logIn }
)(LogInContainer))



// WEBPACK FOOTER //
// ./src/containers/LogIn/index.js